import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import viceprincipal_drRameshKumarAgarwal from "../images/Dr. Ramesh Kumar Agarwal.jpg";



function RameshKumar() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
             <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>
            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Vice Principal <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod"/>
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-3"><b>Message from the Vice Principal  </b></h1>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-3 mt-3">
                                        <div class="card">
                                            <img src={viceprincipal_drRameshKumarAgarwal} className="card-img-top" alt="KPSprincipal" />
                                        </div>

                                    </div>
                                    <div className="col-md-9 mt-3">
                                        <p className='justify mb-2'>Krishnagar Public School is one of the most highly glorified academic institutions in Krishnagar. It is the only school affiliated to CBSE offering the maximum subject combinations at the +2 level in the district of Nadia, West Bengal. </p>
                                        <p className='justify mb-2'>
                            I feel extremely happy and delighted to be a part of such a notable educational institute. Situated in a prime location with close proximity to the central railway station and bus stand, we cater to the educational needs of children far and wide. </p>
                            <p className='justify mb-2'>We at KPS aim at the holistic development of each and every child and as such we stress not only at scholastic aspect but also at the co-scholastic aspect of the individual child. With the ever changing nature of the society, we at KPS try to deliver the best mindset and nurture the creativity and hidden potentials of every child.</p>
                            <p className='justify'>I, being the Vice Principal – with varied experience of international and national boards – assure to be by the side of my children, teachers and parents and provide full cooperation to all related stakeholders. I believe in the dictum that I alone may not have solutions to all the problems but together we can solve them.</p>
                                    </div>
                                   
                                       


                                        <p className='justify mb-2 mt-3'>I am thankful to our Chairman Sir, Director Sir, Trustee Ma’am, Principal Sir, all the members of the School Managing Committee, Headmistress Ma’am (Senior), Headmistress Ma’am (Primary) and my dear teachers for their continuous cooperation in the enhancement of the standard of academics in the institution. I rest my pen with the following lines by renowned poet Robert Frost: </p>
                                        <center>
                                            <h6 style={{color:"#03235b"}} className='mt-4 mb-3'>“The woods are lovely, dark and deep, </h6>
<h6 style={{color:"#03235b"}} className='mb-3'>But I have promises to keep,</h6>
<h6 style={{color:"#03235b"}} className='mb-3'>
And miles to go before I sleep </h6>
<h6 style={{color:"#03235b"}}>And miles to go before I sleep…..” </h6>

                                        </center>
                                </div>
                            </div>
                        </div>
                        <br />





                        <div className="d-flex justify-content-end align-items-end mb-0">
                            
                            <div className='teamkps'>
                                <p className='mb-2'>Thanking You,</p>
                            <p className='mb-3'>Regards & Loads of love</p>
                                <p className='mb-0'>Dr. Ramesh Kumar Agarwal 
                                
                                </p>
                                <h5><b>Vice Principal </b> </h5>
                                <h5>Krishnagar Public School</h5>
                            </div>

                        </div>
                    </div>
                </div>
            </div>



        </div>
    )
}

export default RameshKumar